"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const core_1 = require("companion-app-components/utils/core");
const auth_1 = require("companion-app-components/flux/auth");
const accounts_1 = require("companion-app-components/flux/accounts");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const budgetsActions_1 = require("companion-app-components/flux/budgets/budgetsActions");
const budgetsSelectors_1 = require("companion-app-components/flux/budgets/budgetsSelectors");
const budget_items_1 = require("companion-app-components/flux/budget-items");
const categoryGroupsHelpers_1 = require("companion-app-components/flux/category-groups/categoryGroupsHelpers");
const categoryGroupsSelectors_1 = require("companion-app-components/flux/category-groups/categoryGroupsSelectors");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const objectCache_1 = require("utils/objectCache");
const useQCurrency_1 = __importDefault(require("components/QCurrency/useQCurrency"));
// CUSTOM COMPONENTS
const QCloseBox_1 = __importDefault(require("components/QCloseBox"));
const QButton_1 = __importDefault(require("components/QButton"));
const QCard_1 = __importDefault(require("components/QCard"));
// MUI COMPONENTS
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
// PATH RELATIVE IMPORTS
const BudgetSummary_1 = __importDefault(require("./BudgetSummary"));
const EditBudgetCategoryGroups_1 = __importDefault(require("./EditBudgetCategoryGroups"));
const BudgetAddCategory_1 = __importDefault(require("./BudgetAddCategory"));
const BudgetSuggestedCategories_1 = __importDefault(require("./BudgetSuggestedCategories"));
const subComponents_1 = require("./subComponents");
const editBudgetHelpers_1 = require("./editBudgetHelpers");
const styles_1 = require("./styles");
const utils_1 = require("./utils");
// STYLES HOOK
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
(0, objectCache_1.setMaxCacheSize)(200);
const EditBudgetsDialog = (props) => {
    const { onClose, budget, startDate = new Date(), qCards } = props;
    const { month: startingMonth, year: budgetYear } = luxon_1.DateTime.fromJSDate(startDate);
    // STATE =========================================================================
    const [currency, setCurrency] = (0, react_1.useState)('USD');
    const [dialogTitle, setDialogTitle] = (0, react_1.useState)(null);
    const [showAddCategory, setShowAddCategory] = (0, react_1.useState)(false);
    const [showSuggestedCategories, setShowSuggestedCategories] = (0, react_1.useState)(false);
    const [accountIds, setAccountIds] = (0, react_1.useState)(null);
    const [dateRange, setDateRange] = (0, react_1.useState)((0, utils_1.getBudgetDateRange)(budgetYear, startingMonth));
    const [eoyDateRange, setEoyDateRange] = (0, react_1.useState)({});
    // @ts-expect-error: Only a void function can be called with the 'new' keyword.
    const [catsToExclude, setCatsToExclude] = (0, react_1.useState)(new immutable_1.Set());
    const [qCardsOn, setQCardsOn] = (0, react_1.useState)(Boolean(qCards));
    const [budgetItemsAddedCount, setBudgetItemsAddedCount] = (0, react_1.useState)(0);
    // DISPATCHERS ========================================================================
    const dispatch = (0, react_redux_1.useDispatch)();
    const dispatchCreateBudgetItem = (data) => dispatch(budget_items_1.budgetItemsActions.createBudgetItemsAction([data], { undo: { userMessage: 'New budget item created.' } }));
    const dispatchCreateBudgetItems = (data) => dispatch(budget_items_1.budgetItemsActions.createBudgetItemsAction(data, { undo: { userMessage: 'New budget items created.' } }));
    const dispatchUpdateBudgetItems = (data) => dispatch(budget_items_1.budgetItemsActions.updateBudgetItemsAction(data, { undo: { userMessage: 'Budget items updated.' } }));
    const dispatchDeleteBudget = (data) => dispatch((0, budgetsActions_1.deleteBudgetsAction)([data]));
    const dispatchDeleteBudgetItems = (data) => dispatch(budget_items_1.budgetItemsActions.deleteBudgetItemsAction(data, { undo: { userMessage: 'Budget items deleted.' } }));
    // SELECTORS =========================================================================
    const isMacDataset = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getIsMacDataset(state), react_redux_1.shallowEqual);
    const accountsById = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getAccountsById(state), react_redux_1.shallowEqual);
    const categoryGroupsById = (0, react_redux_1.useSelector)((state) => (0, categoryGroupsSelectors_1.getCategoryGroupsById)(state), react_redux_1.shallowEqual);
    const budgetItems = (0, react_redux_1.useSelector)((state) => budget_items_1.budgetItemsSelectors.getBudgetItemsFiltered(state, Object.assign({ budget }, dateRange)), react_redux_1.shallowEqual);
    const budgetItemsToEndOfYear = (0, react_redux_1.useSelector)((state) => budget_items_1.budgetItemsSelectors.getBudgetItemsFiltered(state, Object.assign({ budget }, eoyDateRange)), react_redux_1.shallowEqual);
    const budgetItemsLoadPending = (0, react_redux_1.useSelector)((state) => budget_items_1.budgetItemsSelectors.getIsLoading(state), react_redux_1.shallowEqual);
    const budgetTreeNodesInternal = (0, react_redux_1.useSelector)((state) => (0, budgetsSelectors_1.getBudgetTreeNodes)(state, Object.assign({ budget }, dateRange)));
    const isEntitySharedUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const budgetTreeNodes = (0, react_1.useMemo)(() => budgetTreeNodesInternal.reverse(), [budgetTreeNodesInternal]);
    const { getAccountsSharedCurrency } = (0, useQCurrency_1.default)();
    const categoryIds = (0, react_1.useMemo)(() => budgetItems.map((budgetItem) => { var _a; return (_a = budgetItem.coa) === null || _a === void 0 ? void 0 : _a.id; }), [budgetItems]);
    // EFFECTS =========================================================================
    /*
     * Determine the date ranges for these budget items
     */
    /* eslint-disable react-hooks/exhaustive-deps */
    (0, react_1.useEffect)(() => {
        const monthVal = startingMonth;
        const budgetDateRange = (0, utils_1.getBudgetDateRange)(budgetYear, monthVal);
        const eoy = luxon_1.DateTime.fromObject({ year: budgetYear, month: 12 }).endOf('year');
        setDateRange({ startDate: budgetDateRange.startDate, endDate: budgetDateRange.endDate });
        setEoyDateRange({ startDate: budgetDateRange.startDate, endDate: eoy });
    }, [startingMonth]);
    /*
     * Determine the currency to use for display of values
     */
    (0, react_1.useEffect)(() => {
        // Determine the currency to use
        let [...idsToUse] = accountsById.keys();
        if (budget.filterAccountIds && budget.filterAccountIds.length > 0) {
            idsToUse = budget.filterAccountIds.map((x) => x.id);
        }
        setCurrency(budget.currency || getAccountsSharedCurrency(idsToUse));
        setAccountIds((0, immutable_1.List)(idsToUse));
    }, [budget, accountsById]); // will run if budget or accounts change
    /*
     * Determine dialog title (editing or creating?)
     */
    (0, react_1.useEffect)(() => {
        // If once budget items are loaded, the size is zero, set isCreating to persist for the whole session
        // we check for startDate, because until the range is set, there are no budget items
        if (!budgetItemsLoadPending && dateRange.startDate && !dialogTitle) {
            if ((isMacDataset && budgetItems.size > 0) || (!isMacDataset && (budgetItems.size > categoryGroupsById.size))) {
                setDialogTitle(`Edit ${luxon_1.DateTime.fromJSDate(startDate).year} Budget for ` +
                    `${luxon_1.DateTime.fromObject({ month: startingMonth }).toFormat('MMMM')}${startingMonth !== 12 ? ' through December' : ''}`);
            }
            else {
                setDialogTitle(`Create a Budget for ${luxon_1.DateTime.fromJSDate(startDate).year}`);
            }
        }
    }, [budgetItemsLoadPending, budgetItems, dateRange, startDate, startingMonth]); // will only run once
    /*
     * Determine currently budgeted coas for filtering
     */
    (0, react_1.useEffect)(() => {
        // determine list of coa items from category list that are already budgeted
        // @ts-expect-error: Only a void function can be called with the 'new' keyword.
        let exclusionSet = new immutable_1.Set();
        budgetItems.forEach((bItem) => {
            if (bItem.coa) {
                const isParent = false; // categoriesById.find((cat) => cat.parentId === bItem.coa.id);
                if (!isParent)
                    exclusionSet = exclusionSet.add((0, objectCache_1.cacheableObject)(bItem.coa));
            }
        });
        setCatsToExclude(exclusionSet);
    }, [budgetItems]);
    const addCategory = (itemInfo) => {
        const groupId = itemInfo.groupId || (0, categoryGroupsHelpers_1.findGroupIdForCategoryId)(categoryGroupsById, itemInfo.coa.id);
        setBudgetItemsAddedCount(budgetItemsAddedCount + 1);
        const itemsToAdd = (0, editBudgetHelpers_1.createNewBudgetItems)(budget, groupId, dateRange, itemInfo);
        core_1.tracker.track(core_1.tracker.events.addedNewBudgetCategory, { number: itemsToAdd.size });
        if (itemsToAdd.size > 1) {
            dispatchCreateBudgetItems(itemsToAdd);
        }
        else {
            dispatchCreateBudgetItem(itemsToAdd.first());
        }
        setShowAddCategory(false);
    };
    /*
     * Ensure there is a Misc category for top level category groups
     * ONLY for empty budgets
     */
    (0, react_1.useEffect)(() => {
        // console.log("CREATING DEFAULT BUDGET NODES", categoryGroupsById.toJS());
        //
        // NOT SUPPORTED BY MAC
        //
        if (!isMacDataset && budgetTreeNodes && budgetItems && !budgetItemsLoadPending && budgetTreeNodes.size === 0) {
            categoryGroupsById.forEach((catGroup) => {
                var _a;
                if ((_a = catGroup.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes('personal')) { // only create misc sections for personal groups
                    if (catGroup.coas && catGroup.coas.length > 0) {
                        const budgetItem = {
                            amount: 0,
                            coa: null,
                            groupId: catGroup.id,
                            budgetItemType: 'GROUP',
                        };
                        // if this item does not already exist, create it
                        if (!budgetItems.find((x) => (x.groupId === budgetItem.groupId) && x.type === 'GROUP')) {
                            addCategory(budgetItem);
                        }
                    }
                }
            });
        }
    }, [budgetTreeNodes, budgetItems, isMacDataset]);
    // STYLES =========================================================================
    const { classes } = useStyles();
    // INTERNAL FUNCTIONS =============================================================
    /*
     * Add Category, called when user selects a category and amount to add to the budget
     * If the category has children budgeted, then we have to create an OTHER value to
     * balance out the L1 value and the children's totals.  We also spread the budget to the end of the year
     */
    const addCategoryItems = (items) => {
        items.forEach((item) => {
            addCategory(item);
        });
        setShowSuggestedCategories(false);
    };
    const getMyItems = (refItem) => budgetItemsToEndOfYear.filter((x) => (x.groupId === refItem.groupId) && (x.type === refItem.type) && chart_of_accounts_1.chartOfAccountsUtils.coasAreEqual(x.coa, refItem.coa)).map((x) => x.set('amount', refItem.amount)).toList();
    const onChange = (changedItem) => {
        // find all other items that need to change
        //
        core_1.tracker.track(core_1.tracker.events.editedBudgetAmount);
        dispatchUpdateBudgetItems(getMyItems(changedItem));
    };
    const onDelete = (itemToDelete) => {
        setBudgetItemsAddedCount(budgetItemsAddedCount - 1);
        core_1.tracker.track(core_1.tracker.events.removedBudgetCategory);
        const toDelete = getMyItems(itemToDelete).map((budgetItem) => budgetItem.set('isDeleted', true));
        dispatchDeleteBudgetItems(toDelete);
    };
    const uniqueBudgetItems = () => {
        // Does not include the group level Misc categories that have no values
        const budgetItemsFiltered = budgetItems.filter((x) => x.type !== 'GROUP' || x.amount !== 0);
        const budgetsGrouped = budgetItemsFiltered.groupBy((x) => `${x.groupId}-${x.type}-${JSON.stringify(x.coa)}`);
        return budgetsGrouped.size;
    };
    const internalOnClose = () => {
        const numItems = uniqueBudgetItems();
        // If there are no relevant budget items, we delete the budget
        if (numItems === 0) {
            // Delete the budget
            if (budget)
                dispatchDeleteBudget(budget.set('isDeleted', true));
        }
        return onClose(uniqueBudgetItems());
    };
    // console.log("BUDGET TREE NODES ", budgetTreeNodes.toJS());
    // RENDER =========================================================================
    return (<>
      {qCards && !isEntitySharedUser &&
            <QCard_1.default open={qCardsOn && !showAddCategory && !showSuggestedCategories} onClose={() => setQCardsOn(false)} cards={qCards} name="WFBudgetSetup" initialCard="firstCard" classes={{ qcard: classes.qCard }}/>}

      <Dialog_1.default maxWidth="xs" open onClose={internalOnClose} classes={{ paperWidthXs: classes.dialogRoot }} disableEscapeKeyDown>
        {showAddCategory &&
            <BudgetAddCategory_1.default onAdd={addCategory} onClose={() => setShowAddCategory(false)} accountIds={accountIds} currency={currency} categoryIds={categoryIds}/>}
        {showSuggestedCategories &&
            <BudgetSuggestedCategories_1.default onAddItems={addCategoryItems} onClose={() => setShowSuggestedCategories(false)} accountIds={accountIds} exclusionSet={catsToExclude} currency={currency}/>}
        <subComponents_1.TitleHeader classes={classes} dialogTitle={dialogTitle || ''} create={!budgetItems || budgetItems.size === (isMacDataset ? 0 : 2)} isMacDataset={isMacDataset}/>
        <BudgetSummary_1.default classes={classes} budgetItems={budgetItems} currency={currency}/>
        <subComponents_1.AddCategoryBlock classes={classes} onAddCategory={() => setShowAddCategory(true)} onSuggestedCategories={() => {
            core_1.tracker.track(core_1.tracker.events.openBudgetSuggestion);
            setShowSuggestedCategories(true);
        }}/>
        <EditBudgetCategoryGroups_1.default 
    // @ts-expect-error: Property 'budgetItems' does not exist on type 'IntrinsicAttributes & EditBudgetCategoryGroupsProps'.
    budgetItems={budgetItems} budgetTreeNodes={budgetTreeNodes} startDate={dateRange.startDate} currency={currency} onChange={onChange} onDelete={onDelete} accountIds={accountIds}/>

        <DialogActions_1.default>
          <QButton_1.default onClick={internalOnClose} id="create-budget-done-button">
            Done
          </QButton_1.default>
        </DialogActions_1.default>

        <QCloseBox_1.default onClose={internalOnClose} id="create-budget-close-button"/>
      </Dialog_1.default>
    </>);
};
exports.default = EditBudgetsDialog;
